import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ButtonGroupContainer } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/button-group-container/main/button-group-container.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { TASK_DETAIL_ACTIVITY_ID } from "../../../processOverview/store/actions";

export function CustomDirtyHandlingContainer(props: View): React.ReactNode {
	const { activityId } = props;

	const initiatingActivityId = useSelector(
		ActivitySelectors.activityPropById(props.activityId, it => it.initiatingActivityId)
	);

	const dispatch = useDispatch();

	const processData = useSelector(ActivitySelectors.data(TASK_DETAIL_ACTIVITY_ID));

	const onAbbrechenClick = React.useCallback(() => {
		dispatch(
			ActivityActions.cancel({
				activityId: activityId
			})
		);
	}, [dispatch, activityId]);

	const onVerwerfenClick = React.useCallback(() => {
		if (!processData || !initiatingActivityId) {
			return;
		}

		dispatch(
			ActivityActions.cancel({
				activityId: activityId
			})
		);

		dispatch(
			ActivityActions.setData({
				activityId: initiatingActivityId,
				data: processData,
				dirty: false
			})
		);

		dispatch(
			FormEngineActions.command({
				activityId: initiatingActivityId,
				engineEvent: Commands.setReadonly(true)
			})
		);

		dispatch(
			FormEngineActions.command({
				activityId: TASK_DETAIL_ACTIVITY_ID,
				engineEvent: Commands.setReadonly(false)
			})
		);

		dispatch(
			FormEngineActions.command({
				activityId: initiatingActivityId,
				engineEvent: Commands.setMessageState({
					messages: {}
				})
			})
		);
	}, [initiatingActivityId, dispatch, processData, activityId]);

	return (
		<ModalNotification
			variant="warning"
			title="Wirklich abbrechen?"
			footer={
				<ButtonGroupContainer>
					<ButtonGroup alignment="right">
						<Button label="Abbrechen" secondary onClick={onAbbrechenClick} />
						<Button label="Verwerfen" destructive primary onClick={onVerwerfenClick} />
					</ButtonGroup>
				</ButtonGroupContainer>
			}
		>
			<p>Wollen Sie wirklich die getätigten Änderungen verwerfen?</p>
		</ModalNotification>
	);
}
